import React, { Component } from 'react';

const ProjectContext = React.createContext();

export const ProjectConsumer = ProjectContext.Consumer;

class ProjectProvider extends Component {

    render() {

        return (
            <ProjectContext.Provider value={
                this.props.value ?
                    this.props.value
                    :
                    {
                        iriGeneration: 'PREFLABEL',
                        defaultLang: "en",
                        projectLang: "en",
                        hasComponent: [],
                        largeDataSettings: false,
                        projectDatatype: [],
                        skosXL: false,
                        ontologyProjectAssociation: []
                    }
            }>
                {this.props.children}
            </ProjectContext.Provider>
        );
    }
}

export default ProjectProvider;
